import { Chip, Icon, Tooltip } from "@material-ui/core"
import { FC, useEffect, useState, useMemo } from "react"
import { FORMAS_PAGAMENTO, ETAPAS_PAGAMENTO, SITUACOES_PAGAMENTO, ETAPA_PAGAMENTO_NEGOCIACAO, FINANCIAMENTO, CARTAO_FINANCIAMENTO, PIX_FINANCIAMENTO, BOLETO_FINANCIAMENTO, SITUACAO_PAGAMENTO_PENDENTE, ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO, ETAPA_PAGAMENTO_DADOS_CLIENTE, ETAPA_PAGAMENTO_FORMAS_PAGAMENTO, ETAPA_PAGAMENTO_FATURAMENTO } from "src/constants"
import { Formater, LocalStorage, SessionStorage, TypeRecords, UrlUtil } from "src/framework/commons"
import { InputInfo } from "src/framework/components/forms"
import { CupomDescontoEfetivar, PedidoType, TTIPO_TERMO_ACEITE } from "src/types"
import { MdOutlineFlashOn } from 'react-icons/md';
import "./styles.scss"
import { green, red } from "@material-ui/core/colors"
import { PagamentoListagemComponentes } from "../../PagamentoListagemComponentes"
import { IoTicket } from "react-icons/io5"
import { FullWidthButton } from "src/framework/components/buttons"
import { ModalCupom } from "../../cupom/ModalCupom"
import { BaixarBoleto } from "../../negociacao/BaixarBoleto"
import { IDataResponse, STATUS_CODE } from "src/framework/providers/api"
import { PagamentosProvider } from "src/providers"
import { useHistory } from "react-router-dom"
import { EtapasPagamento } from "../EtapasPagamento"
import { FinanciamentoIndiretoDocumentos } from "../../negociacao/FinanciamentoIndiretoDocumentos"
import { PedidoStore } from "src/store/vendas/PedidoStore"
import { FinanciamentoForm } from "../../negociacao/Financiamento"
import { confirmationDialog, doLogOut, isLoggedIn$, notifierStore } from "src/framework/store"
import { FinanciamentoDocumentos } from "../../negociacao/FinanciamentoDocumentos"
import { TermosDeAceite } from "../../termos/TermosDeAceite"
import { ITermosPagamentos } from "src/providers/cadastros/TermosAceiteProvider/types"
import { GerarQRCodePix } from "../../negociacao/GerarQRCodePix"
import { FaExclamationTriangle, FaRegFilePdf } from "react-icons/fa"
import theme from "src/theme/light"
import { PedidosProvider } from "src/providers/pagamentos/PedidoProvider"

interface CardPedidoProperties {
    pedido: PedidoType | null;
    statusServicoCupom: any;
    onReload?: () => void;
    widthScreen: number;
}

const pagamentosProvider = new PagamentosProvider();
const pedidosProvider = new PedidosProvider();

const CardPedido: FC<CardPedidoProperties> = ({
    pedido,
    statusServicoCupom,
    onReload,
    widthScreen
}) => {

    const history = useHistory();

    const [openCuponDesconto, setOpenCuponDesconto] = useState<boolean>(false);
    const [openBaixarBoleto, setOpenBaixarBoleto] = useState<boolean>(false);
    const [openFinancimentoForm, setOpenFinancimentoForm] = useState<boolean>(false);
    const [openFinanciamentoIndiretoDocumentos, setOpenFinanciamentoIndiretoDocumentos] = useState<boolean>(false);
    const [openFinanciamentoDocumento, setOpenFinanciamentoDocumento] = useState<boolean>(false);
    const [openTermosAceite, setOpenTermoAceite] = useState(false);
    const [openGerarPix, setOpenGerarPix] = useState<boolean>(false);
    const uploadInfo =  LocalStorage.get("solar.uploadInfo",  true);

    const efetivarCupon = async (cupom: CupomDescontoEfetivar): Promise<void> => {
        const response = await pagamentosProvider.efetivaCupom(cupom);

        if (response.statusCode === STATUS_CODE.OK) {
            setOpenCuponDesconto(false);
            if (onReload) {
                onReload();
            }
        }
    }

    const parseTipoDocumento = (tipo: string): string => {
        if (tipo === "proposta") {
            return "Proposta"
        }

        if (tipo === "proposta_financiamento") {
            return "Proposta financiamento"
        }

        if (tipo === "nota_fiscal") {
            return "Nota Físcal"
        }

        return "";
    }

    const valorTotal = (): number => {
        const _valor = Number(pedido?.valor_pedido) - Number(pedido?.valor_desconto);
        return Number(Number(_valor).toFixed(2))
    }

    const redirectEtapas = (termos: ITermosPagamentos) => {
        if (pedido?.codigo_venda) {
            const cupomDesconto = pedido.codigo_cupom ? { codigo: pedido.codigo_cupom, valor_desconto: pedido.valor_desconto } : undefined;

            pagamentosProvider.savePagamentosPedido(pedido?.codigo_venda, termos, cupomDesconto).then((response: IDataResponse) => {
                if (response.statusCode === STATUS_CODE.OK) {
                    if (response.data) {
                        // pedido.pagamentos = response.data.pagamento;
                        pedido.pagamento_id = response.data.pagamento?.id;
                        PedidoStore.setPedido(pedido)
                        history.push("/etapa/cliente");
                    }
                }
            });
        }
    }

    const prosseguir = () => {
        if (pedido?.etapa_pagamento === ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO.id) {
            PedidoStore.setPedido(pedido)
            PedidoStore.setPedidoRedirect(pedido)
            history.push("/etapa/pagamento");
        } else {
            setOpenTermoAceite(true);
        }
    }

    const validarAcoes = (): string => {
        if (pedido?.acoes?.carta_credito) {
            return "Incluir Carta de Crédito";
        } else if (pedido?.acoes?.comprovante_pagamento) {
            return "Incluir Comprovante de Pagamento";
        } else if (pedido?.acoes?.financiamento_documentos) {
            return "Formalização de Financiamento";
        } else if (pedido?.acoes?.boleto) {
            return "Gerar Boleto";
        } else if (pedido?.acoes?.financiamento_proposta) {
            return "Formulário de Financiamento";
        } else if (pedido?.acoes?.pix) {
            return "Gerar Pix";
        }else if(pedido?.etapa_pagamento === ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO.id){
            return "Prosseguir com complemento"
        }

        return "Prosseguir";
    }

    const onDeleteCupom = () => {

        // valida se pode ou não fazer a exclusão do cupom
        // se o cliente já selecionou forma de pagamento não permite exclusão
        /*
        if (pedido?.pagamento_id) {
            notifierStore.setNotifier({
                title: "Aviso",
                content: "Etapa onde se encontra o pedido não permiti exclusão de cupom",
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false);
                }
            })
            notifierStore.setOpen(true)
            return;
        }
        */

        // realiza exclusão de cupom
        confirmationDialog.setup({
            title: "Aviso!",
            content: "Confirma exclusão de cupom de desconto?",
            onConfirmation: async () => {
                if (!pedido?.codigo_venda) return;
                const responsePedido: IDataResponse<PedidoType[]> = await pedidosProvider.getPedidos(pedido.codigo_venda);
                if (responsePedido.statusCode !== STATUS_CODE.OK) return;

                pagamentosProvider.excluirCupom(pedido?.codigo_cupom || "", pedido?.codigo_venda || "").then((response: IDataResponse) => {
                    const message: string[] = [];

                    if (response.statusCode === STATUS_CODE.OK) {
                        message.push("Exclusão realizada com sucesso!");
                        if (onReload) {
                            onReload();
                        };
                    } else {
                        if (Array.isArray(response.message)) {
                            message.push(...response.message);
                        } else {
                            message.push(response.message);
                        }
                    }

                    notifierStore.setNotifier({
                        title: "Aviso",
                        content: message,
                        timeOut: 3500,
                        onClose: async () => {
                            notifierStore.setOpen(false);

                            if (message.some((msg: string) => msg.includes("vigência") && msg.includes("encerrado"))) {
                                const redirectURL = await doLogOut();
                                if (redirectURL) {
                                    window.location.href = redirectURL
                                    LocalStorage.removeAll();
                                    SessionStorage.removeAll();
                                    isLoggedIn$.next(false);
                                }
                            }
                        }
                    })
                    notifierStore.setOpen(true)
                });
                confirmationDialog.close()
            },
            onClose: () => {
                confirmationDialog.close()
            }
        })
        confirmationDialog.open()
        return;
    };

    const gerarBoleto = () => {
        pagamentosProvider.gerarBoleto(pedido?.codigo_venda || "").then((response: IDataResponse) => {
            if (response.statusCode === STATUS_CODE.OK) {
                if (onReload) {
                    onReload();
                    setOpenBaixarBoleto(true);
                };
            } else {

                notifierStore.setNotifier({
                    title: "Aviso",
                    content: response.message,
                    timeOut: 3500,
                    onClose: () => {
                        notifierStore.setOpen(false);
                    }
                })
                notifierStore.setOpen(true)
            }
        })
    }

    const openBoleto = (abrirBoleto: boolean): void => {
        if (abrirBoleto) {
            const boletos = [...pedido?.pagamentos?.boletos || []].shift()

            if (boletos?.situacao === "pendente") {
                gerarBoleto();
                return;
            }
            setOpenBaixarBoleto(true);
        }
    }

    useEffect(() => {

        if (pedido?.id === PedidoStore.getPedidoRedirect()?.id) {
            const abrirCartaCredito: boolean = pedido?.acoes?.carta_credito || false
            const abrirComprovantePagamento: boolean = pedido?.acoes?.comprovante_pagamento || false
            const abrirFinanciamentoProposta: boolean = pedido?.acoes?.financiamento_proposta || false
            const abrirFinanciamentoDocumentos: boolean = pedido?.acoes?.financiamento_documentos || false
            const abrirBoleto: boolean = pedido?.acoes?.boleto || false
            const abrirPix: boolean = pedido?.acoes?.pix || false

            if (abrirCartaCredito || abrirComprovantePagamento) {
                setOpenFinanciamentoIndiretoDocumentos(true);
            }

            if (abrirFinanciamentoProposta) {
                setOpenFinancimentoForm(true)
            }

            if (abrirFinanciamentoDocumentos && !abrirFinanciamentoProposta) {
                setOpenFinanciamentoDocumento(true);
            }

            openBoleto(abrirBoleto);

            if (abrirPix) {
                setOpenGerarPix(true);
            } 
        }
    }, []);

    const removeCupomDesconto = useMemo((): boolean => {
        if (!pedido) {
            return false;
        }

        // Etapas iniciais
        if (pedido?.situacao === null && pedido?.etapa_pagamento === null) {
            return true;
        }

        return pedido?.situacao === "pendente" && (pedido?.etapa_pagamento === "dados_cliente" || pedido?.etapa_pagamento === "formas_pagamento");
    }, [pedido?.situacao, pedido?.etapa_pagamento]);

    return <div className="CardPedido">
        <div className="row">
            <div className="X12">
                <div className="header">
                    <div className="codigo">
                        <Tooltip title="Código do Pedido">
                            <Chip label={pedido?.codigo_venda} size="small" />
                        </Tooltip>
                        &nbsp;
                        {pedido?.potencia && (
                            <Tooltip title="Potência">
                                <Chip variant="outlined" label={<><MdOutlineFlashOn className="icon-potencia" />&nbsp;{`${Formater.toString(pedido?.potencia, TypeRecords.DECIMAL2)} kW`}</>} size="small" />
                            </Tooltip>
                        )}
                        &nbsp;
                        {pedido?.codigo_cupom && (
                            <Tooltip title="Cupom de Desconto">
                                <Chip
                                    variant="outlined"
                                    color="primary"
                                    label={<><IoTicket />&nbsp;{pedido?.codigo_cupom}</>}
                                    size="small"
                                    deleteIcon={removeCupomDesconto ? <Icon className="cupom-close-icon">close</Icon> : undefined}
                                    onDelete={async () => {
                                        if (!pedido.codigo_venda) return;
                                        const responsePedido: IDataResponse<PedidoType[]> = await pedidosProvider.getPedidos(pedido.codigo_venda);
                                        if (responsePedido.statusCode !== STATUS_CODE.OK) return;
                                        if(removeCupomDesconto) onDeleteCupom();
                                    }}
                                />
                            </Tooltip>
                        )}
                        &nbsp;
                        {pedido?.documentos?.length ? <>
                            {pedido?.documentos?.filter((_doc) => _doc.tipo !== "nota_fiscal" && _doc.tipo !== "proposta_financiamento")?.map((doc: any, index: number) => {
                                return <Tooltip title={parseTipoDocumento(doc.tipo)}>
                                    <Chip
                                        variant="outlined"
                                        color="default"
                                        label={<><FaRegFilePdf size={"10px"}/>&nbsp;{parseTipoDocumento(doc.tipo)}</>}
                                        size="small"
                                        deleteIcon={<Icon>download</Icon>}
                                        onDelete={async () => {
                                            if (!pedido.codigo_venda) return;
                                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return
                                            const responsePedido: IDataResponse<PedidoType[]> = await pedidosProvider.getPedidos(pedido.codigo_venda);
                                            if (responsePedido.statusCode !== STATUS_CODE.OK) return
                                            UrlUtil.goto(`//${uploadInfo?.data?.url}${doc.url}`, true);
                                        }}
                                    />
                                </Tooltip>
                            })}
                        </> : ""}
                        &nbsp;
                        {pedido?.data_expiracao && (
                            <Tooltip title="Validade do Projeto">
                                <Chip
                                    style={{ backgroundColor: theme.palette.error.main, color: theme.palette.error.contrastText }}
                                    color="default"
                                    variant="outlined"
                                    label={<><FaExclamationTriangle color={theme.palette.warning.main} />&nbsp;Validade do Projeto: {Formater.toString(pedido?.data_expiracao, TypeRecords.DATE)}</>}
                                    size="small"
                                />
                            </Tooltip>
                        )}
                    </div>

                </div>
            </div>
        </div>

        <div className="X12">
            <div className="row">
                <div className="X12 M6">
                    <div className="row">
                        <div className="X12">
                            <InputInfo
                                label="E-mail Proposta"
                                text={pedido?.email_proposta} />
                        </div>
                        <div className={widthScreen <= 950 ? "X12" : "X6 S8"}>
                            <InputInfo
                                label="Revenda"
                                text={pedido?.revenda_nome || pedido?.distribuidor_nome} />
                        </div>
                        {widthScreen <= 950 ? <>
                            <div className="X12">
                                <InputInfo
                                    label="Tipo pagamento"
                                    text={pedido?.forma_pagamento_id ? FORMAS_PAGAMENTO[pedido?.forma_pagamento_id].nome : "Não selecionado"} />
                            </div>

                            <div className="X6 S4">
                                <InputInfo
                                    label="Situação"
                                    text={pedido?.situacao ? SITUACOES_PAGAMENTO[pedido?.situacao].nome : "Aguardando Pagamento"} />
                            </div>
                        </> : <>
                            <div className="X6 S4">
                                <InputInfo
                                    label="Situação"
                                    text={pedido?.situacao ? SITUACOES_PAGAMENTO[pedido?.situacao].nome : "Aguardando Pagamento"} />
                            </div>

                            <div className="X6 S4">
                                <InputInfo
                                    label="Tipo pagamento"
                                    text={pedido?.forma_pagamento_id ? FORMAS_PAGAMENTO[pedido?.forma_pagamento_id].nome : "Não selecionado"} />
                            </div>
                        </>}

                        <div className="X6 S4">
                            <InputInfo
                                label="Última etapa"
                                text={pedido?.etapa_pagamento ? ETAPAS_PAGAMENTO[pedido?.etapa_pagamento].nome : "Pedido recebido"} />
                        </div>
                    </div>

                </div>

                <div className="X12 M6">
                    <div className="row row-card-pedido">
                        <div className="valores-container X12">
                            <div className="valores">
                                <div className="valor-item valor-pedido">
                                    <div className="texto">Subtotal</div>
                                    <div className="valor"><span></span><span>{Formater.toString(pedido?.valor_pedido, TypeRecords.CURRENCY)}</span></div>
                                </div>
                                <div className="valor-item valor-desconto">
                                    <div className="texto">Desconto</div>
                                    <div className="valor" style={{ color: pedido?.valor_pendente ? green[500] : "inherit" }}><span>- </span><span>{`${Formater.toString(pedido?.valor_desconto, TypeRecords.CURRENCY)}${pedido?.percentual_desconto ? " (" + Formater.toString(pedido?.percentual_desconto, TypeRecords.PERCENT2) + ")" : ""}`}</span></div>
                                </div>
                                <div className="valor-item valor-desconto">
                                    <div className="texto">Frete</div>
                                    <div className="valor" ><span></span>Grátis</div>
                                </div>
                                <div className="valor-item valor-pago">
                                    <div className="texto">Total</div>
                                    <div className="valor"><span>- </span><span>{Formater.toString(valorTotal(), TypeRecords.CURRENCY)}</span></div>
                                </div>
                                <div className="valor-item valor-pago">
                                    <div className="texto">Valor pago</div>
                                    <div className="valor"><span>- </span><span>{Formater.toString(pedido?.valor_pago, TypeRecords.CURRENCY)}</span></div>
                                </div>
                                <div className="valor-item valor-pendente">
                                    <div className="texto">Valor pendente</div>
                                    <div className="valor" style={{ color: pedido && pedido.valor_pendente > 0.0 || pedido?.pagamento_id === null ? red[500] : "inherit" }}><span></span><span>{Formater.toString(pedido?.valor_pendente, TypeRecords.CURRENCY)}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="X12">
            <div className="row">
                <div className="X12 S--order1 M--order1">
                    {pedido && (<div className="row PedidoVigentePaperProsseguir X--reverse">

                        {/* Prosseguir */}
                        {(pedido?.etapa_pagamento === null || [ETAPA_PAGAMENTO_DADOS_CLIENTE.id, ETAPA_PAGAMENTO_FORMAS_PAGAMENTO.id, ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO.id].includes(String(pedido?.etapa_pagamento))) && <>
                            <div className="buttons X12 S6 M4 L2">
                                <FullWidthButton
                                    text={`Prosseguir${pedido?.etapa_pagamento === ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO.id ? " com complemento" : ""}`}
                                    color={"primary"}
                                    variant={"contained"}
                                    disableElevation
                                    onClick={async () => {
                                        const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido?.codigo_venda || "")
                                        if (substituicaoResult.statusCode !== STATUS_CODE.OK) return;
                                        prosseguir();
                                    }}
                                />
                            </div>
                        </>}

                        {/* Botão gerar boleto */}
                        {pedido?.acoes?.boleto && <>
                            <div className="buttons X12 S6 M4 L2">
                                <FullWidthButton
                                    text={"Gerar Boleto"}
                                    color={"primary"}
                                    variant={"contained"}
                                    disableElevation
                                    onClick={async() => {
                                        const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido?.codigo_venda || "")
                                        if (substituicaoResult.statusCode !== STATUS_CODE.OK) return
                                        openBoleto(true)
                                    }}
                                />
                            </div>
                        </>}

                        {/* Botão gerar pix */}
                        {pedido?.acoes?.pix && <>
                            <div className="buttons X12 S6 M4 L2">
                                <FullWidthButton
                                    text={"Gerar Pix"}
                                    color={"primary"}
                                    variant={"contained"}
                                    disableElevation
                                    onClick={async () => {
                                        const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido?.codigo_venda || "")
                                        if (substituicaoResult.statusCode !== STATUS_CODE.OK) return;
                                        setOpenGerarPix(true);
                                    }}
                                />
                            </div>
                        </>}

                        {/* Botão formulário de financiamento */}
                        {pedido?.acoes?.financiamento_proposta && <>
                            <div className="buttons X12 S6 M4 L2">
                                <FullWidthButton
                                    text={"Formulário de Financiamento"}
                                    color={"primary"}
                                    variant={"contained"}
                                    disableElevation
                                    onClick={async() => {
                                        const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido?.codigo_venda || "")
                                        if (substituicaoResult.statusCode !== STATUS_CODE.OK) return
                                        setOpenFinancimentoForm(true);
                                    }}
                                />
                            </div>
                        </>}

                        {/* Botão documentos de financiamento */}
                        {(!pedido?.acoes?.financiamento_proposta && pedido?.acoes?.financiamento_documentos) && <>
                            <div className="buttons X12 S6 M4 L2">
                                <FullWidthButton
                                    text={"Formalização de Financiamento"}
                                    color={"primary"}
                                    variant={"contained"}
                                    disableElevation
                                    onClick={async () => {
                                        const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido?.codigo_venda || "")
                                        if (substituicaoResult.statusCode !== STATUS_CODE.OK) return;
                                        setOpenFinanciamentoDocumento(true);
                                    }}
                                />
                            </div>
                        </>}


                        {/* Botão documentos de financiamento */}
                        {(pedido?.acoes?.carta_credito || pedido?.acoes?.comprovante_pagamento) && <>
                            <div className="buttons X12 S6 M4 L2">
                                <FullWidthButton
                                    text={`Incluir ${pedido?.acoes?.carta_credito ? "Carta de Crédito" : " Comprovante de Pagamento"}`}
                                    color={"primary"}
                                    variant={"contained"}
                                    disableElevation
                                    onClick={async () => {
                                        const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido?.codigo_venda || "")
                                        if (substituicaoResult.statusCode !== STATUS_CODE.OK) return
                                        setOpenFinanciamentoIndiretoDocumentos(true);
                                    }}
                                />
                            </div>
                        </>}
                       
                        {([ETAPA_PAGAMENTO_DADOS_CLIENTE.id, ETAPA_PAGAMENTO_FORMAS_PAGAMENTO.id].includes(String(pedido?.etapa_pagamento)) || pedido?.etapa_pagamento === null) ? <>
                            {statusServicoCupom?.ativo && !pedido?.codigo_cupom && (<>
                                <div className="buttons X12 S6 M4 L3">
                                    <FullWidthButton
                                        variant="outlined"
                                        color="secondary"
                                        onClick={async () => {
                                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido?.codigo_venda || "")
                                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return
                                            setOpenCuponDesconto(true)
                                        }}
                                        text="Cupom de desconto"
                                        startIcon={<><IoTicket style={{ marginRight: "7px" }} /> </>}
                                    />
                                </div>
                            </>)}

                        </> : null}
                        {/* {(pedido?.etapa_pagamento === ETAPA_PAGAMENTO_NEGOCIACAO.id && [BOLETO.id, BOLETO_CARTAO.id, BOLETO_FINANCIAMENTO.id, BOLETO_FINANCIAMENTO_INDIRETO.id].includes(Number(pedido?.forma_pagamento_id))) && (<>
                            <div className="buttons X12 S6 M4 L2">
                                <FullWidthButton
                                    variant="outlined" color="secondary"
                                    disabled={pedido.pagamentos?.boletos && pedido.pagamentos?.boletos[0].situacao === "pendente" ? true : false}
                                    onClick={() => {
                                        setOpenBaixarBoleto(true)
                                    }}
                                    text="Baixar Boleto"
                                    startIcon={<><FaBarcode style={{ marginRight: "7px" }} /></>}
                                />
                            </div>
                        </>)} */}
                    </div>)}
                </div>

                <div className="X12 S--order2 M--order2">
                    <PagamentoListagemComponentes itens={pedido?.itens} />
                </div>
                
                {pedido !== null && (
                    <div className="X12 X--order3">
                        <EtapasPagamento pedido={pedido} />
                    </div>
                )}
            </div>
        </div>

        <TermosDeAceite
            codigoPedido={String(pedido?.codigo_venda)}
            open={openTermosAceite}
            tipo={TTIPO_TERMO_ACEITE.PEDIDO}
            onConfirm={(_termos) => {
                PedidoStore.setPedidoRedirect(pedido)
                const termosPagamento: ITermosPagamentos = {
                    termos_aceite: {
                        termos: _termos.termos
                    }
                }

                if (_termos.data_previsao_faturamento && _termos?.estabelecimento && _termos?.estabelecimento > 0) {
                    termosPagamento.faturamento = {
                        data_previsao: _termos.data_previsao_faturamento,
                        estabelecimento: _termos?.estabelecimento,
                    }
                }

                if (pedido?.codigo_venda) {
                    if (pedido.codigo_cupom && pedido.pagamento_id) {
                        pagamentosProvider.validarCupom({
                            cupom: pedido.codigo_cupom,
                            uf: pedido?.estado_id ? pedido?.estado_id : "",
                            potencia: pedido?.potencia ? pedido?.potencia : 0,
                            codigoVenda: pedido?.codigo_venda ? pedido?.codigo_venda : "",
                        }).then((response: IDataResponse) => {
                            if (response.statusCode === STATUS_CODE.OK) {
                                redirectEtapas(termosPagamento);
                            } else {
                                notifierStore.setNotifier({
                                    title: "Aviso",
                                    content: response.message,
                                    timeOut: 3500,
                                    onClose: () => {
                                        notifierStore.setOpen(false);
                                        if (onReload) {
                                            onReload();
                                        }
                                    }
                                })
                                notifierStore.setOpen(true)
                            }
                        });
                    } else {
                        redirectEtapas(termosPagamento);
                    }
                }
            }}
            onClose={() => {
                setOpenTermoAceite(false);
            }}
        />

        <ModalCupom
            pedido={pedido}
            statusServicoCupom={statusServicoCupom}
            open={openCuponDesconto}
            onCancel={() => {
                setOpenCuponDesconto(false)
            }}
            onConfirm={(cupom: CupomDescontoEfetivar) => {
                efetivarCupon(cupom);
            }}
        />
        {pedido?.codigo_venda && pedido?.acoes?.boleto && <BaixarBoleto
            open={openBaixarBoleto}
            onClose={() => {
                setOpenBaixarBoleto(false)
            }}
            onConfirm={() => {
                setOpenBaixarBoleto(false);
                if (onReload && pedido?.acoes?.boleto) {
                    onReload();
                };
            }}
            pagamentoId={pedido?.pagamento_id}
        />}
        {pedido?.codigo_venda && (pedido?.acoes?.comprovante_pagamento || pedido?.acoes?.carta_credito) && <FinanciamentoIndiretoDocumentos
            open={openFinanciamentoIndiretoDocumentos}
            pedido={pedido}
            onClose={() => {
                setOpenFinanciamentoIndiretoDocumentos(false)
            }}
            onConfirm={() => {
                setOpenFinanciamentoIndiretoDocumentos(false);
                if (onReload) {
                    onReload();
                };
            }} />}
        {pedido?.codigo_venda && pedido?.acoes?.financiamento_documentos && <FinanciamentoDocumentos
            open={openFinanciamentoDocumento}
            pedido={pedido}
            onClose={() => {
                setOpenFinanciamentoDocumento(false);
            }}
            onConfirm={(_close) => {
                setOpenFinanciamentoDocumento(_close);
                if (onReload) {
                    onReload();
                };
            }} />}
        {pedido?.codigo_venda && pedido?.acoes?.pix && <GerarQRCodePix
            codigo_venda={pedido?.codigo_venda}
            open={openGerarPix}
            onConfirm={() => { }}
            onClose={() => {
                setOpenGerarPix(false);
                if (onReload) {
                    onReload();
                }
            }}
        />}
        {pedido?.codigo_venda && pedido?.acoes?.financiamento_proposta && <FinanciamentoForm
                codigoVenda={pedido?.codigo_venda}
                open={openFinancimentoForm}
                onClose={() => {
                    setOpenFinancimentoForm(false);
                    if (onReload) {
                        onReload();
                    }
                }}
                onConfirm={() => { }}
            />}
    </div>
}

export { CardPedido }